<template>
  <video
    ref="videoPlayer"
    autoplay
    muted
    playsinline
    loop
    class="w-full h-full object-cover"
  ></video>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import Hls from 'hls.js';

const props = defineProps({
  videoSrc: String,
});
const videoPlayer = ref(null);

let hls = null;

onMounted(() => {
  if (Hls.isSupported()) {
    hls = new Hls();
    hls.loadSource(props.videoSrc);
    hls.attachMedia(videoPlayer.value);
    hls.on(Hls.Events.MANIFEST_PARSED, () => {
      videoPlayer.value.play();
    });
  } else if (videoPlayer.value.canPlayType('application/vnd.apple.mpegurl')) {
    videoPlayer.value.src = videoSrc;
    videoPlayer.value.play();
  }
});

onUnmounted(() => {
  if (hls) {
    hls.destroy();
  }
});
</script>
